module.exports = __webpack_public_path__ + "static/sharmi_shah-735d7385f47e708f050cb506ea099802.jpg";